<div class="modal-v2 confirm-email-modal">
  <div class="modal-v2-header">
    <div class="modal-v2-title">
      {{ 'confirm_email_modal.title' | translate }}
    </div>

    <button
      class="modal-v2-close"
      (click)="dialogRef.close({ type: state() === 'success' ? 'CONFIRM' : 'CANCEL' })"
    >
      <tc-icon iconType="close"></tc-icon>
    </button>
  </div>

  <div class="modal-v2-content">
    @if (state() === 'title') {
      @let email = customerService.customer2().contactInfo.email;
      <div
        class="description html-description"
        [innerHTML]="'confirm_email_modal.description' | translate:{ email }"
      >
      </div>

      @if (error()) {
        <div class="form__error">
          {{ error() }}
        </div>
      }
    } @else if (state() === 'otp') {
      <tc-otp
        [otpRequest]="otpRequest()"
        [otpDigitsFormArray]="otpDigitsFormArray"
        [isLoading]="isLoading()"
        [error]="error()"
        (submit)="onSubmit()"
        (resendOtp)="confirmEmailInit()"
      >
      </tc-otp>
    } @else {
      <div class="success-header">
        {{ 'confirm_email_modal.success_header' | translate }}
      </div>

      <div class="success-text html-description">
        {{ 'confirm_email_modal.success_text' | translate }}
      </div>
    }

    @if (state() !== 'otp') {
      <tc-button
        class="form-submit"
        [isLoading]="isLoading()"
        buttonSize="large"
        (click)="onSubmit()"
      >
        @if (state() === 'title') {
          {{ 'global.send_otp' | translate }}
        } @else {
          {{ 'global.done' | translate }}
        }
      </tc-button>
    }
  </div>
</div>
